export default __webpack_public_path__ + "static/shipping-8-c91c7d7c34e813d57185c6ca1cdce65e.jpg";